import type { CeoDebtInstrument } from '@shared/api';
import { formatDateRu, formatMoney } from '../ceoFormat';
import {
  InfoCard,
  InfoGrid,
  InfoKey,
  InfoRow,
  InfoVal,
  SectionTitle,
  TextNote,
} from './styles';

interface DebtDetailInfoCardsProps {
  inst: CeoDebtInstrument;
}

export function DebtDetailInfoCards({ inst }: DebtDetailInfoCardsProps) {
  const isLeasing = inst.instrument_type === 'leasing';
  const isGuarantee = inst.instrument_type === 'bank_guarantee';

  return (
    <InfoGrid>
      <InfoCard>
        <SectionTitle>Паспорт и реквизиты обслуживания</SectionTitle>
        <InfoRow>
          <InfoKey>
            {isGuarantee
              ? 'Принципал (Заёмщик)'
              : 'Заёмщик / Лизингополучатель'}
          </InfoKey>
          <InfoVal>{inst.borrower_entity?.trim() || '—'}</InfoVal>
        </InfoRow>
        <InfoRow>
          <InfoKey>
            {isGuarantee
              ? 'Банк-гарант'
              : 'Кредитор / Лизингодатель'}
          </InfoKey>
          <InfoVal>{inst.creditor_name}</InfoVal>
        </InfoRow>
        <InfoRow>
          <InfoKey>Период действия</InfoKey>
          <InfoVal>
            {formatDateRu(inst.start_date)} — {formatDateRu(inst.end_date)}
          </InfoVal>
        </InfoRow>
        <InfoRow>
          <InfoKey>Счёт безакцептного списания</InfoKey>
          <InfoVal>
            {inst.settlement_bank_name
              ? `${inst.settlement_bank_name} (${inst.settlement_account_number})`
              : 'Основной р/с'}
          </InfoVal>
        </InfoRow>
        <InfoRow>
          <InfoKey>Ответственный руководитель</InfoKey>
          <InfoVal>{inst.responsible_person ?? 'Финансовая дирекция'}</InfoVal>
        </InfoRow>
      </InfoCard>

      <InfoCard>
        <SectionTitle>
          {isLeasing
            ? 'Предмет лизинга, техника и выкупные условия'
            : 'Обеспечение, залог и финансовые ковенанты'}
        </SectionTitle>
        {isLeasing && (
          <>
            <InfoRow>
              <InfoKey>Предмет лизинга (спецтехника)</InfoKey>
              <InfoVal>{inst.leased_asset_name ?? 'Строительная техника'}</InfoVal>
            </InfoRow>
            <InfoRow>
              <InfoKey>Количество единиц в парке</InfoKey>
              <InfoVal>{inst.leased_asset_count} ед.</InfoVal>
            </InfoRow>
            <InfoRow>
              <InfoKey>Остаточная выкупная стоимость</InfoKey>
              <InfoVal>{formatMoney(inst.residual_buyout_amount)}</InfoVal>
            </InfoRow>
          </>
        )}
        <TextNote>
          <strong>Обеспечение / залог:</strong>{' '}
          {inst.collateral_summary ?? 'Без залога имущества'}
        </TextNote>
        <TextNote>
          <strong>Ковенанты банка:</strong>{' '}
          {inst.covenants_summary ?? 'Стандартные ковенанты обслуживания долга'}
        </TextNote>
        {inst.notes && (
          <TextNote>
            <strong>Примечание казначейства:</strong> {inst.notes}
          </TextNote>
        )}
      </InfoCard>
    </InfoGrid>
  );
}
